<section class="drawer">
  <ng-content select="[sidebar]"></ng-content>
</section>
<section class="content">
  <ng-content select="[content]"></ng-content>
</section>
